import { useTranslation } from 'libs/i18n'
import { useForm } from 'react-hook-form'
import { InputGroup } from 'shared/molecules'
import { Field, fieldButtonClassName } from '../Field'
import { Position, usePlacement } from '../../placement'
import { useTextValidationSchema } from './hooks/useTextValidationSchema'

type TextProps = {
	floormapConfig: any[]
	onSubmit: (data: any) => void
}

export const Text = ({ floormapConfig, onSubmit }: TextProps) => {
	const { t } = useTranslation()
	const validationResolver = useTextValidationSchema()

	const {
		handleSubmit,
		register,
		formState: { errors }
	} = useForm({
		resolver: validationResolver,
		mode: 'onChange'
	})

	const submitText = (data: any, position: Position = { x: 85, y: 90 }) => {
		onSubmit([
			...floormapConfig,
			{
				type: 'text',
				...position,
				text: data.textLayerValue,
				shadowBlur: 10,
				draggable: true,
				id: crypto.randomUUID()
			}
		])
	}

	usePlacement('text', (position) => handleSubmit((data) => submitText(data, position))())

	return (
		<Field label={t('Text')} section="text" isPlaceable>
			<form className="space-y-2" onSubmit={handleSubmit((data) => submitText(data))}>
				<InputGroup
					id="floor-map-text"
					label={t('Text')}
					placeholder={t('add text')}
					{...register('textLayerValue')}
					error={(errors as any).textLayerValue}
				/>
				<button type="submit" className={fieldButtonClassName}>
					{t('Add text')}
				</button>
			</form>
		</Field>
	)
}
